import { ObjectType } from '@convergence/types';
import { AnalysisActionSwitch } from './analysis-action-switch';
import { ActionInputProps } from './types';

export function AnalysisObjectAction(props: ActionInputProps<ObjectType>) {
  const fields = Object.entries(props.value._fields) ?? [];

  return (
    <div className="border-l mb-">
      <div className="font-bold mb-2">{props.name}</div>
      {fields.map(([key, value]) => (
        <AnalysisActionSwitch
          key={`${props.propertyPath.join('.')}_fields_${key}`}
          name={key}
          tree={props.tree}
          onChange={props.onChange}
          value={value}
          propertyPath={[...props.propertyPath, '_fields', key]}
          errors={props.errors}
        />
      ))}
    </div>
  );
}
